import { CompanyDto } from './companyDto'
import { InboundTripPAPSDto } from './inboundTripPAPSDto'
import { VehicleDto } from './vehicle'
import * as yup from 'yup'

export class MichiganTitleDto {
  michiganTitleGuid?: string = undefined
  vehicle?: VehicleDto = undefined
  inboundTripPAPS?: InboundTripPAPSDto = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  ownerName?: string = undefined
  ownerAddress?: string = undefined
  ownerCity?: string = undefined
  ownerCountry?: string = undefined
  ownerStateProvince?: string = undefined
  ownerPostalCode?: string = undefined
  ownerPhone?: string = undefined
  ownerIRSNumber?: string = undefined
  ownerDealerNumber?: string = undefined
  specialMailerName?: string = undefined
  specialMailerAddress?: string = undefined
  specialMailerCity?: string = undefined
  specialMailerStateProvince?: string = undefined
  specialMailerPostalCode?: string = undefined
  registeredImporterWillNotReceiveTitle?: boolean = undefined
  baseMSRP?: string = undefined
  // lienHolderCompany?: CompanyDto = undefined
  lienHolderCompanyName?: string = undefined
  lienHolderCompanyAddress?: string = undefined
  vehiclePurchaseAgreementEffectiveDate?: string = undefined
  documentSigner?: string = undefined
  policeBookNumber?: number = undefined
  papsNumber?: string = undefined
  applicationPacketReadyToPrintDateTime?: string = undefined
  applicationPacketReadyForMiSosBundleDateTime?: string = undefined
}

export const MichiganTitleValidationSchema = yup.object().shape({
  michiganTitleGuid: yup.string().nullable(),
  ownerName: yup.string().nullable(),
  ownerAddress: yup.string().nullable(),
  ownerCity: yup.string().nullable(),
  ownerCountry: yup.string().nullable(),
  ownerStateProvince: yup.string().nullable(),
  ownerPostalCode: yup.string().nullable(),
  ownerPhone: yup.string().nullable(),
  ownerIRSNumber: yup.string().nullable(),
  ownerDealerNumber: yup.string().nullable(),
  specialMailerName: yup.string().nullable(),
  specialMailerAddress: yup.string().nullable(),
  specialMailerCity: yup.string().nullable(),
  specialMailerStateProvince: yup.string().nullable(),
  specialMailerPostalCode: yup.string().nullable(),
  registeredImporterWillNotReceiveTitle: yup.boolean().nullable(),
  baseMSRP: yup.string().nullable(),

  lienHolderCompanyName: yup.string().nullable(),
  lienHolderCompanyAddress: yup.string().nullable(),

  vehiclePurchaseAgreementEffectiveDate: yup.string().nullable(),
  documentSigner: yup.string().nullable(),
  policeBookNumber: yup.number().nullable(),
  papsNumber: yup.string().nullable(),
  applicationPacketReadyToPrintDateTime: yup.string().nullable(),
  applicationPacketReadyForMiSosBundleDateTime: yup.string().nullable(),
  vehicle: yup.object().nullable(),
  inboundTripPAPS: yup.object().nullable(),
  exporterCompany: yup.object().nullable(),
  buyerCompany: yup.object().nullable()
})
